import { useClientBranding } from '../contexts/ClientBrandingContext';
import {
  DOCUMENT,
  documentAuthButtonSx,
  documentAuthBrandedButtonSx,
} from '../constants/documentTheme';
import { partnerAuthName } from '../utils/clientInvite';
import { isUsableImageUrl } from '../utils/itineraryItemImage';
import { clientBrandingAppliesPageTheme } from '../utils/partnerWorkspaceBrand';
import useClientInvitePreview from './useClientInvitePreview';

/**
 * Invite preview wins when `?brand=` is present; otherwise a stored Bespoke
 * session keeps login, register, and reset branded.
 */
const useAuthPageBranding = () => {
  const { token: brandToken, branding: previewBranding } = useClientInvitePreview();
  const { branding: sessionBranding } = useClientBranding();
  const branding = previewBranding || sessionBranding;
  const brandName = partnerAuthName(branding);
  const brandColor = branding?.color || DOCUMENT.accent;
  const applyTheme = clientBrandingAppliesPageTheme(branding);

  return {
    brandToken,
    branding,
    brandName,
    brandColor,
    brandLogoUrl: isUsableImageUrl(branding?.logoUrl) ? branding.logoUrl : null,
    applyTheme,
    buttonSx: applyTheme
      ? documentAuthButtonSx
      : documentAuthBrandedButtonSx(brandName ? brandColor : null),
  };
};

export default useAuthPageBranding;
